export const languageElements = {
  items: {
    "tracking-system-title": {
      hu: "ÁRU NYOMKÖVETÉS",
      de: "TRACKING SYSTEM",
      en: "TRACKING SYSTEM",
    },

    "tracking-system-descr": {
      hu: "Légi és tengeri fuvarok nyomonkövetése",
      de: "Sendungsverfolgung zur AFF/OFF Lieferungen",
      en: "Track & Trace of AFF/OFF shipments",
    },

    "yusen-vantage-title": {
      hu: "YUSEN VANTAGE",
      de: "YUSEN VANTAGE",
      en: "YUSEN VANTAGE",
    },

    "yusen-vantage-descr": {
      hu: "Yusen Logisitics új, egyesített IT platformja",
      de: "Neue einheitliche IT-Plattform von Yusen Logistics",
      en: "Yusen Logistic's New Unified IT Platform",
    },
  },
};
